var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"loading":_vm.loading}},[_c('div',{attrs:{"id":"wp-content"}},[_vm._l((_vm.layouts),function(layout,index){return _c('BaseLayout',{key:index,attrs:{"layoutData":layout}})}),_c('vue-headful',{attrs:{"title":_vm.pageTitle,"description":_vm.pageDescription,"keywords":_vm.pageKeywords}})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }